import { makeStyles } from '@material-ui/core/styles';


export default () => {
    let useStyles = makeStyles({ 
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '15px 0px !important',
            '& > span': {
                fontSize: 20,
                fontWeight: 700
            }
        },
        drop:{
            background:"#ffffff",
            width:"140px",
            height:"35px",
            paddingLeft:"10px",
            paddingRight:"10px",
            marginLeft:"8px",
            borderRadius:"6px",
            marginTop:"3px",
            color:"#112B42",
            fontSize: 14,
            boxShadow: '0 5px 4px #d8d8d8'
        },
        boxtotalinvoice:
        {
            display: 'flex',
            justifyContent: 'space-between',
            background: '#EFF7FE',
            borderRadius: '8px',
            height: '85px',  
            marginBottom: '25px',
            padding: "0px 90px 0px 90px",
            alignItems: 'center'
        },
        totalamount:
        {
            
            marginTop:'10px',
            color:"#7F7F7F"
        },

    })
    return useStyles();
}